module.exports = __webpack_public_path__ + "img/txtImg.e5394f97.png";